<script lang="ts">
import {Vue, Component} from 'vue-facing-decorator';
import { noderedInstances } from '@/assets/nodered.instances';

@Component({})
export default class NodeRedEditor extends Vue {
  private activeTab = 0;
  private loading = false;
  private nodeRedInstances: { id: number; name: string; domainName: string; }[] = [];

  private mounted() {
    this.nodeRedInstances = noderedInstances;
  }

  private get domainName() {
    const domainId = this.$route.params.id;
    return this.nodeRedInstances[Number(domainId) - 1]?.domainName;
  }

  private get dashboardLoginPath() {
    return (process.env.VUE_APP_NR_LOGIN_PATH || 'ea4dac95-58e2-4c0a-a296-e25383519aee/login').trim().replace(/^\/|\/$/g, '');
  }

  private get nodeRedEditorUrl() {
    return `https://${this.domainName}/auth/strategy/?token=${localStorage.getItem('token')}`;
  }

  private get nodeRedDashboardUrl() {
    return `https://${this.domainName}/${this.dashboardLoginPath}?token=${encodeURIComponent(localStorage.getItem('token') || '')}`;
  }

}
</script>

<template>
  <div class="fill-height embed-container overflow-x-hidden">
    <v-card color="#F4F4F4" variant="flat" class="pa-2 d-flex align-center" height="48" >
      <v-row dense align="center">
        <v-col cols="6" md="8">
          <v-row no-gutters align="center">
            <v-col cols="4" md="auto">
              <v-btn size="small" :variant="activeTab === 0 ? 'text' : 'plain'" @click="activeTab = 0" color="primary">
                Editor
              </v-btn>
            </v-col>
            <v-col cols="4" md="auto">
              <v-btn size="small" :variant="activeTab === 1 ? 'text' : 'plain'" @click="activeTab = 1" color="primary">
                Dashboard
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
    <v-progress-linear v-if="loading" :indeterminate="loading" color="primary" height="4" style="z-index: 99"></v-progress-linear>
    <v-card variant="flat" class="rounded-0 pa-0" :class="loading ? 'mt-n1' : ''" style="z-index: 98;" height="calc(100% - 48px)">
      <v-window v-model="activeTab" class="fill-height">
        <v-window-item value="editor" class="fill-height">
          <div class="fill-height embed-container overflow-x-hidden">
            <iframe ref="frame" class="embed-container" width="100%" height="100%" style="border: none" :src="nodeRedEditorUrl"></iframe>
          </div>
        </v-window-item>
        <v-window-item value="dashboard" class="fill-height">
          <div class="fill-height embed-container overflow-x-hidden">
            <iframe ref="frame" class="embed-container" width="100%" height="100%" style="border: none" :src="nodeRedDashboardUrl"></iframe>
          </div>
        </v-window-item>
      </v-window>
    </v-card>
  </div>
</template>

<style scoped>

</style>